import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "information-container tw-flex tw-items-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "information tw-flex tw-mr-12 tw-items-center tw-gap-2" }
const _hoisted_4 = { class: "name-value" }
const _hoisted_5 = { class: "tw-items-center tw-inline-flex" }
const _hoisted_6 = { class: "tw-items-center tw-inline-flex tw-ml-[5px]" }
const _hoisted_7 = { class: "tw-items-center tw-inline-flex" }
const _hoisted_8 = {
  key: 0,
  class: "domain-value"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatusBadge = _resolveComponent("StatusBadge")!
  const _component_CellTableAction = _resolveComponent("CellTableAction")!
  const _component_CustomTable = _resolveComponent("CustomTable")!

  return (_openBlock(), _createBlock(_component_CustomTable, {
    columns: _ctx.tableFields,
    data: _ctx.tableData,
    "is-loading": _ctx.loading,
    "empty-text": _ctx.getUiText('app-settings-domains-table-empty-domain-list-1'),
    onUpdateSelectedRows: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSelectDomain($event)))
  }, {
    "cell(domain)": _withCtx((data) => [
      _createElementVNode("div", _hoisted_1, [
        (data.value.imgSrc)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: data.value.imgSrc,
              alt: "person_random"
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(data.value), 1)
        ])
      ])
    ]),
    "cell(status)": _withCtx((data) => [
      _createVNode(_component_StatusBadge, {
        value: data.value
      }, null, 8, ["value"])
    ]),
    "cell(isVerified)": _withCtx((data) => [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.isVerified[data.value.isVerifiedDNS].className, "cell-status-domain tw-flex tw-items-center"])
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.isVerified[data.value.isVerifiedDNS].label), 1)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.isEmailVerified[data.value.isVerifiedEmail].className, "cell-status-domain tw-flex tw-items-center"])
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.isEmailVerified[data.value.isVerifiedEmail].label), 1)
        ], 2)
      ])
    ]),
    "cell(fromDate)": _withCtx((data) => [
      _createElementVNode("div", _hoisted_7, [
        (data?.item?.startDate)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.convertUTCTimeToLocalTime(data.item.startDate)), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    "cell(action)": _withCtx((data) => [
      _createVNode(_component_CellTableAction, {
        id: 'domain-table-' + data.item.id,
        "data-cy": 'domain-table-' + data.idx,
        value: data,
        "is-internal": false,
        actions: _ctx.optionDomainActions(data),
        onManageUser: _ctx.handleManageDomain
      }, null, 8, ["id", "data-cy", "value", "actions", "onManageUser"])
    ]),
    _: 1
  }, 8, ["columns", "data", "is-loading", "empty-text"]))
}